export default __webpack_public_path__ + "static/media/made-easy-2.a93e3530.png";